import React from "react";

import mixpanel from "../../../../lib/mixPanel";

import PhoneInput from "../../../Common/PhoneInput";
import SmsVerification from "../../../../routes/screens/Users/Profile/SmsVerification";

const DesktopEdit = ({
  handleSubmit,
  showErrors,
  formErrors,
  firstName,
  lastName,
  email,
  emailVerified,
  mobileNumber,
  active,
  handleChange,
  submitPhoneNumber,
  smsVerified,
  sendSmsVerificationKey,
  openEditSection,
  sendEmailVerificationKey,
  smsVerification,
  onSmsVerified,
  closeVerification,
  togglePasswordSection
}) => {
  return (
    <div className="col-sm-8 col-md-6">
      {smsVerification && (
        <SmsVerification
          mobileNumber={mobileNumber}
          onSmsVerified={onSmsVerified}
          closeVerification={closeVerification}
          sendSmsVerificationKey={sendSmsVerificationKey}
        />
      )}
      <form onSubmit={handleSubmit}>
        <div className="white-bg">
          <div
            className={`form-group hide-xs ${(showErrors &&
              formErrors &&
              formErrors["firstName"] &&
              "error") ||
              ""}`}
          >
            <input
              id="firstName"
              className="form-input"
              value={firstName}
              type="text"
              autoCapitalize="none"
              placeholder="First Name"
              onChange={e => handleChange(e)}
            />
            <span>
              {(showErrors &&
                formErrors &&
                formErrors["firstName"] &&
                formErrors["firstName"]) ||
                ""}
            </span>
          </div>
          <div
            className={`form-group hide-xs  ${(showErrors &&
              formErrors &&
              formErrors["lastName"] &&
              "error") ||
              ""}`}
          >
            <input
              id="lastName"
              className="form-input"
              autoCapitalize="none"
              value={lastName}
              type="text"
              placeholder="Last Name"
              onChange={e => handleChange(e)}
            />
            <span>
              {(showErrors &&
                formErrors &&
                formErrors["lastName"] &&
                formErrors["lastName"]) ||
                ""}
            </span>
          </div>
          <div
            className={`form-group hide-xs ${(!emailVerified && "verified") ||
              ""} ${(showErrors &&
              formErrors &&
              formErrors["email"] &&
              "error") ||
              ""}`}
          >
            <input
              id="email"
              className="form-input"
              autoCapitalize="none"
              value={email}
              type="text"
              placeholder="Email"
              onChange={e => handleChange(e)}
            />
            <span>
              {(showErrors &&
                formErrors &&
                formErrors["email"] &&
                formErrors["email"]) ||
                ""}
            </span>
            <a
              className="verified-div d-flex align-items-center cursor-pointer"
              onClick={e =>
                (emailVerified && e.preventDefault()) ||
                sendEmailVerificationKey()
              }
            >
              {!emailVerified && (
                <>
                  <label>Not Verified</label>
                  <i className="icon icon-arrow-left rotate" />
                </>
              )}
            </a>
          </div>
          <PhoneInput
            className="hide-xs"
            submitPhoneNumber={submitPhoneNumber}
            defaultNumber={mobileNumber}
            showErrors={showErrors}
            smsVerified={smsVerified}
            sendSmsVerificationKey={sendSmsVerificationKey}
          />
          <div
            className="form-group visible-xs"
            onClick={() => openEditSection("name")}
          >
            <div className="form-div">
              <a className="cursor-pointer">
                <p className="description">Name</p>
                <p className="value">
                  {firstName} {lastName}
                </p>
              </a>
              <a className="right-icon cursor-pointer">
                <img src="/png/chevron-right.png" />
              </a>
            </div>
          </div>
          <div
            className="form-group visible-xs"
            onClick={() => openEditSection("email")}
          >
            <div className="form-div">
              <a className="cursor-pointer">
                <p className="description">E-mail Address</p>
                <p className="value">{email}</p>
              </a>
              <a className="right-icon cursor-pointer">
                <img src="/png/chevron-right.png" />
              </a>
            </div>
          </div>
          <div
            className="form-group visible-xs"
            onClick={() => {
              mixpanel.track("Change Phone Number Click");
              openEditSection("mobileNumber");
            }}
          >
            <div className="form-div">
              <a className="cursor-pointer">
                <p className="description">Mobile Phone Number</p>
                <p className="value">{mobileNumber}</p>
              </a>
              <a className="right-icon cursor-pointer">
                <img src="/png/chevron-right.png" />
              </a>
            </div>
          </div>
          <a
            className="cursor-pointer change-password hide-xs"
            onClick={togglePasswordSection}
          >
            <p className="description">Change your password</p>
            <a className="right-icon">
              <img src="/png/chevron-right.png" />
            </a>
          </a>
          <div
            className="form-group visible-xs"
            onClick={() => openEditSection("password")}
          >
            <div className="form-div">
              <a className="cursor-pointer">
                <p className="description">Password</p>
                <p className="value">******</p>
              </a>
              <a className="right-icon cursor-pointer">
                <img src="/png/chevron-right.png" />
              </a>
            </div>
          </div>
        </div>
        <div className="use-buttons">
          <button
            className={`btn btn-sign register-button hide-xs ${(active &&
              "active") ||
              ""}`}
            type="submit"
          >
            <span>Save</span>
          </button>
        </div>
      </form>
    </div>
  );
};

export default DesktopEdit;
